export default "__VITE_ASSET__BBrCKkiq__"